import { render, staticRenderFns } from "./calification.vue?vue&type=template&id=3565a5d3"
import script from "./calification.vue?vue&type=script&lang=ts"
export * from "./calification.vue?vue&type=script&lang=ts"
import style0 from "./calification.vue?vue&type=style&index=0&id=3565a5d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports